import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=edc574e8"
import script from "./ClientEdit.vue?vue&type=script&lang=js"
export * from "./ClientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports